import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'

import { useTheme } from '../../../../context/theme'
import {
  setFilterItem,
  removeFilterItem
} from '../../../../redux/designerReducers/itemsReducer'

import Accordion from '../../../DesignerCommon/Accordion'
import ListTabs from '../tabs/ListTabs'
import { ReactComponent as CheckIcon } from '../../../../assets/check.svg'

import useOnClickOutside from '../../../../hooks/useOnClickOutside'
import { on, off } from '../../../../hooks/useCustomEvent'
import { ASSET_URL } from '../../../../constants/ApiEndpoints'

const catalog = require('../../../../redux/data/categories.json')
const colors = require('../../../../redux/data/colors.json')
const stores = require('../../../../redux/data/store.json')
const designstyles = require('../../../../redux/data/style.json')

const Container = styled.div`
  margin-top: 9px;
  margin-left: 16px;
  margin-right: 16px;
  overflow-y: auto;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.background.secondary};

  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  align-content: flex-start;

  @media (max-width: 800px) {
    position: fixed;
    max-height: 70vh;
    bottom: 10vh;
    left: 0;
    right: 0;
    z-index: 999999;
  }
`

const ListingContainer = styled.div`
  flex: 1 1 auto;
  /*overflow-y: auto;*/
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;

  overflow-y: auto;

  height: ${props => (props.isCatalog ? 'auto' : '0')};

  @media (max-width: 800px) {
    height: ${props => (props.isCatalog ? '63vh' : '0')};
  }
`

const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: stretch;

  /*margin-top: 14px;*/
  user-select: none;
  /*overflow-y: auto;*/
`

const FilterItemContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  /*padding: 14px;*/
  padding-left: 16px;
  padding-top: 11px;
  padding-bottom: 11px;
  cursor: pointer;
  font-size: 13px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.062);
  /*border-bottom: 0.5px solid #d8d8d8;*/
`

const FilterItemCheckBox = styled.div`
  width: 18px;
  height: 18px;
  border: 1px solid ${props => props.theme.accordion.text};
  margin-right: 8px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;

  ${props =>
    props.select === true &&
    `
    border: 1px solid #FF5E6D;
    background-color: #FF5E6D;
  `}
`

const Check = styled(CheckIcon)`
  padding: 0;
  margin: 0;
  visibility: ${props => (props.select === 'true' ? 'visible' : 'hidden')};
`

const FilterColorContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 11px;
  font-size: 10px;
  margin: 25px;
  user-select: none;
`

const FilterColorSwatchContainer = styled.div`
  border: ${props =>
    props.select === false ? `1px solid transparent` : `1px solid #FF5E6D`};
  padding: 4px;
`

const FilterColorItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 2px;
  cursor: pointer;
`

const FilterColorSwatch = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${props => props.theme.redacted};
`

const Label = styled.div`
  color: ${props => props.theme.accordion.text};
`

const Button = styled.button`
  background-color: ${props =>
    props.active === true
      ? props.theme.background.secondary
      : props.theme.background.secondary};
  cursor: pointer;
  padding: 1px 16px;
  display: flex;
  align-items: center;
  border: none;
  outline: none;

  &:hover {
    background-color: ${props => props.theme.accordion.highlight};
  }
`

const IconImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  filter: ${props => (props.scheme === 'dark' ? 'invert(100%)' : 'invert(0%)')};
`

const Title = styled.p`
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: ${props => props.theme.text.primary};
  margin-right: auto;
`

//----------------------------------------------------------------
// BRAND & STYLE
//----------------------------------------------------------------

const CheckCard = ({ label, altLabel, value, type }) => {
  const dispatch = useDispatch()
  const { filters } = useSelector(state => state.items)
  const [select, setSelected] = useState(false)

  useEffect(() => {
    const check = filters.filter(e => e.value === value)
    if (check && check.length > 0) setSelected(true)
    else setSelected(false)
  }, [filters, value])

  const handleClick = () => {
    if (select === true) {
      dispatch(removeFilterItem({ value }))
      return
    }
    const obj = {
      label,
      value,
      type
    }
    dispatch(setFilterItem(obj))
  }

  return (
    <FilterItemContainer onClick={handleClick}>
      <FilterItemCheckBox select={select}>
        <Check select={select.toString()} />
      </FilterItemCheckBox>
      <Label>{altLabel ? altLabel : label}</Label>
    </FilterItemContainer>
  )
}

const CatalogCheckCard = ({
  label,
  altLabel,
  value,
  type,
  catid,
  allSubcategories
}) => {
  const dispatch = useDispatch()
  const { filters } = useSelector(state => state.items)
  const [select, setSelected] = useState(false)

  useEffect(() => {
    const check = filters.filter(e => e.value === value)
    if (check && check.length > 0) setSelected(true)
    else setSelected(false)
  }, [filters, value])

  const handleClick = () => {
    if (select === true) {
      dispatch(removeFilterItem({ value }))
      return
    }
    const obj = {
      label,
      value,
      type,
      catid
    }
    dispatch(setFilterItem(obj))
  }

  return (
    <FilterItemContainer onClick={handleClick}>
      <FilterItemCheckBox select={select}>
        <Check select={select.toString()} />
      </FilterItemCheckBox>
      <Label>{altLabel ? altLabel : label}</Label>
    </FilterItemContainer>
  )
}

const SubCatalogList = ({ data, catid }) => {
  if (!data || data?.length === 0) return <></>

  return (
    <FilterContainer>
      {data.map((s, i) => (
        <CatalogCheckCard
          key={i}
          label={s.name.charAt(0).toUpperCase() + s.name.substring(1)}
          value={s.value}
          catid={catid}
          type="categoryIds"
        />
      ))}
    </FilterContainer>
  )
}

const BrandsList = () => {
  return (
    <FilterContainer>
      {stores.map((s, i) => (
        <CheckCard
          key={i}
          label={s.storeName}
          value={s.indixStoreId}
          type="storeIds"
        />
      ))}
    </FilterContainer>
  )
}

const StylesList = ({ onUpdate }) => {
  return (
    <FilterContainer>
      {designstyles.map((s, i) => (
        <CheckCard key={i} label={s.name} value={s.Id} type="styles" />
      ))}
    </FilterContainer>
  )
}

//----------------------------------------------------------------
// COLOR
//----------------------------------------------------------------

const ColorCard = ({ data, appearance }) => {
  const dispatch = useDispatch()
  const { filters } = useSelector(state => state.items)
  const [select, setSelected] = useState(false)

  useEffect(() => {
    const check = filters.filter(e => e.value === data.value)
    if (check && check.length > 0) setSelected(true)
    else setSelected(false)
  }, [filters, data])

  const handleClick = () => {
    if (select === true) {
      dispatch(removeFilterItem({ value: data.value }))
      return
    }
    const obj = {
      label: data.label,
      value: data.value,
      type: 'colorDesigns'
    }
    dispatch(setFilterItem(obj))
  }

  return (
    <FilterColorItemContainer onClick={handleClick}>
      <FilterColorSwatchContainer select={select}>
        <FilterColorSwatch
          style={{
            border:
              appearance === 'light'
                ? data.border && data.border
                : data.borderDark && data.borderDark,
            background: data.background ? data.background : data.color,
            backgroundSize: 'contain'
          }}
        />
      </FilterColorSwatchContainer>
      <Label>{data.label}</Label>
    </FilterColorItemContainer>
  )
}

const ColorsList = ({ appearance }) => {
  return (
    <FilterColorContainer>
      {colors.map(c => (
        <ColorCard key={c.value} data={c} appearance={appearance} />
      ))}
    </FilterColorContainer>
  )
}

const taboptions = [
  {
    value: 'catalog',
    label: 'Catalog'
  },
  {
    value: 'sort',
    label: 'Sort By'
  }
]

const AdvanceFilterList = ({
  filterData,
  exclude,
  include,
  useLocal,
  hideSort,
  isTabsVisible = true,
  isSubcategoryAllowed = true,
  onOptionClick,
  handleClose,
  isVisible,
  prependCategories = [],
  ...props
}) => {
  const containerRef = useRef(null)
  const [tabSelected, setTabSelected] = useState(taboptions[0])
  const { filters } = useSelector(state => state.items)
  const { appearance } = useTheme()

  const [tabs, setTabs] = useState(taboptions)
  const [cat, setCat] = useState(catalog)

  useOnClickOutside(containerRef, () => {
    if (isVisible && handleClose) setTimeout(() => handleClose(), 150)
  })

  useEffect(() => {
    if (!isSubcategoryAllowed)
      setCat([
        ...prependCategories,
        ...catalog,
        {
          shortName: 'Others',
          name: 'others',
          children: [],
          iconName: 'others1.svg'
        }
      ])
  }, [isSubcategoryAllowed, prependCategories])

  const handleTabClick = tab => {
    setTabSelected(tab)
  }

  useEffect(() => {
    if (!hideSort) {
      setTabs(taboptions)
    } else {
      var temp = [...taboptions]
      temp = temp.filter(t => t.value !== 'sort')
      setTabs(temp)
    }
  }, [hideSort])

  useEffect(() => {
    if (!exclude) return

    var temp = [...catalog]
    exclude.forEach(e => {
      temp = temp.filter(c => c.value !== e)
    })

    setCat(temp)
  }, [exclude])

  useEffect(() => {
    if (!include) return

    var temp = []
    include.forEach(i => {
      const item = catalog.filter(c => c.value === i)
      if (item && item.length > 0) {
        temp = [...temp, ...item]
      }
    })

    setCat(temp)
  }, [include])

  useEffect(() => {
    const handleJumpTo = e => {
      if (e.detail.type === 'categoryIds') setTabSelected(taboptions[0])
      else setTabSelected(taboptions[1])
    }

    on('jumpTo', handleJumpTo)

    return () => {
      off('jumpTo', handleJumpTo)
    }
  }, [])

  return (
    <Container {...props} ref={containerRef}>
      {isTabsVisible && (
        <ListTabs
          options={tabs}
          selected={tabSelected}
          onClick={handleTabClick}
        />
      )}
      <ListingContainer
        isCatalog={tabSelected.value === 'catalog'}
        style={{
          visibility: tabSelected.value === 'catalog' ? 'visible' : 'hidden'
        }}
      >
        {cat.map(c =>
          isSubcategoryAllowed ? (
            <Accordion
              key={c.value}
              title={c.shortName}
              id={c.value}
              data={c}
              icon={ASSET_URL + 'designer/category/' + c.iconName}
              haveOptions={c.subCategories?.length > 0 ? true : false}
              selections={useLocal ? filterData : filters}
            >
              {!c.disableAll && (
                <CatalogCheckCard
                  altLabel="All"
                  allSubcategories={c.allSubCategories}
                  label={c.shortName}
                  value={c.value}
                  catid={c.value}
                  type="categoryIds"
                />
              )}
              <SubCatalogList data={c.subCategories} catid={c.value} />
            </Accordion>
          ) : (
            <Button active={false} onClick={() => onOptionClick(c)}>
              <IconImage
                src={ASSET_URL + 'designer/category/' + c.iconName}
                scheme={appearance}
              />
              <Title>{c.shortName}</Title>
            </Button>
          )
        )}
      </ListingContainer>
      {!hideSort && (
        <ListingContainer
          style={{
            visibility: tabSelected.value === 'sort' ? 'visible' : 'hidden',
            height: tabSelected.value === 'sort' ? 'auto' : '0'
          }}
        >
          <Accordion title="Color" haveOptions={true}>
            <ColorsList appearance={appearance} />
          </Accordion>
          <Accordion title="Brand" haveOptions={true}>
            <BrandsList />
          </Accordion>
          <Accordion title="Style" haveOptions={true}>
            <StylesList />
          </Accordion>
        </ListingContainer>
      )}
    </Container>
  )
}

export default AdvanceFilterList
